let __ttWmLogoImg = null;

async function loadWmLogo(srcUrl) {
  if (__ttWmLogoImg?.src === srcUrl) return __ttWmLogoImg;

  const img = new Image();
  img.crossOrigin = "anonymous";
  img.src = srcUrl;
  await img.decode();

  __ttWmLogoImg = img;
  return img;
}

export async function makeWatermarkedThumbWithLogo(srcUrl, logoUrl) {
  const img = new Image();
  img.crossOrigin = "anonymous";
  img.src = srcUrl;
  await img.decode();

  const size = 512;
  const c = document.createElement("canvas");
  c.width = size;
  c.height = size;
  const ctx = c.getContext("2d");

  // cover crop
  const r = Math.max(size / img.width, size / img.height);
  const w = img.width * r;
  const h = img.height * r;
  const x = (size - w) / 2;
  const y = (size - h) / 2;
  ctx.drawImage(img, x, y, w, h);

  // watermark logo
  const logo = await loadWmLogo(logoUrl);

  ctx.save();
  ctx.globalAlpha = 0.22;

  // centered, larger watermark
  const targetW = Math.round(size * 0.65);
  const aspect = logo.height / logo.width;
  const targetH = Math.round(targetW * aspect);

  ctx.drawImage(
    logo,
    (size - targetW) / 2,
    (size - targetH) / 2,
    targetW,
    targetH
  );

  ctx.restore();

  return c.toDataURL("image/jpeg", 0.9);
}